import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import { darken, rgba } from 'polished';
import { FormattedMessage } from 'react-intl';

const GamblingWarning: React.VFC = () => {
  const theme = useTheme();
  return (
    <Box
      bgcolor={rgba(theme.palette.warning.main, 0.08)}
      p={4}
      color={darken(0.13, theme.palette.warning.main)}
    >
      <Typography variant="subtitle1" component="p" color="inherit">
        <FormattedMessage id="game.details.gambling_warning.title" />
      </Typography>
      <Typography variant="body2" color="inherit">
        <FormattedMessage id="game.details.gambling_warning.body" />
      </Typography>
    </Box>
  );
};

export default GamblingWarning;
